import { render, staticRenderFns } from "./PagePaginateControl.vue?vue&type=template&id=b48ae05c"
import script from "./PagePaginateControl.vue?vue&type=script&lang=js"
export * from "./PagePaginateControl.vue?vue&type=script&lang=js"
import style0 from "./PagePaginateControl.vue?vue&type=style&index=0&id=b48ae05c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports